<template>
  <Loader v-model="loading" />
  <PublicNavbar />
  <div class="landing-page-wrapper pt-15">
    <VContainer class="mt-4">
      <BreadcrumbState class="px-0 py-2" />
      <VRow class="cws-container cws-sidebar-right blog-wrapper pt-4">
        <!-- content -->
        <VCol
          cols="9"
          class="blog-detail-wrapper"
        >
          <VRow>
            <!-- blogs -->
            <VCol cols="12">
              <VCard
                v-if="typeof newContent === 'object'"
                :title="newContent.CCNT_title"
              >
                <VListItem v-if="newContent.postAuthor">
                  <template
                    v-if="auth && auth.loggedIn"
                    #prepend
                  >
                    <VAvatar
                      class="mr-50"
                      href="javascript:void(0)"
                      size="24"
                      :src="newContent.postAuthor.profile.profilephoto.FILE_url"
                    />
                  </template>
                  <VListItemTitle v-if="auth && auth.loggedIn">
                    <small class="text-muted mr-50">por {{ newContent.postAuthor.profile.PRFL_names + ' ' +newContent.postAuthor.profile.PRFL_lastnames }} </small>
                    <span class="text-muted ml-75 mr-50">|</span>
                  </VListItemTitle>
                  <VListItemSubtitle>
                    <UseTimeAgo 
                      v-slot="{ timeAgo }"
                      :time="newContent.CCNT_published_at?newContent.CCNT_published_at.date:newContent.CCNT_created_at.date" 
                      :messages="messages"
                    >
                      {{ timeAgo }}
                    </UseTimeAgo>
                  </VListItemSubtitle>
                </VListItem>
                <div class="my-1 py-25 d-flex">
                  <div
                    v-for="tag in newContent.CCNT_page_keywords.split(',')"
                    :key="tag"
                  >
                    <VChip
                      pill
                      class="mx-2"
                    >
                      {{ tag }}
                    </VChip>
                  </div>
                </div>
                <div class="blog-content">
                  <div class="ccntImage">
                    <VImg :src="portadasUrl+newContent.CCNT_featured_image" />
                  </div>
                  <TipTapPrinter v-model="newContent.CCNT_content" />
                </div>

                <!-- user commnets -->
                <VList>
                  <VListItem
                    v-for="user in newContent.UserComment"
                    :key="user.USRL_PK"
                  >
                    <template #prepend>
                      <VAvatar
                        size="60"
                        :src="user.avatar"
                      />
                    </template>
                    <VListItemTitle>
                      <h6 class="font-weight-bolder">
                        {{ user.fullName }}
                      </h6>
                      <VCardText>
                        {{ user.comment }}
                      </VCardText>
                    </VListItemTitle>
                  </VListItem>
                </VList>
              </VCard>
            </VCol>
          </VRow>
        </VCol>
        <!-- sidebar -->
        <VCol
          cols="3"
          class="blog-sidebar py-2 py-lg-0"
        >
          <!-- related posts -->
          <div
            v-if="typeof newContent === 'object' && typeof newContent.related === 'object'"
            class="blog-recent-posts mt-3"
          >
            <h6 class="section-label mb-75">
              {{ $t('CMSRelatedPost') }}
            </h6>
            <template
              v-for="(recentpost,index) in newContent.related"
              :key="recentpost.CCNT_PK"
            >
              <NuxtLink
                class="nav-link flex items-center"
                :to="{ path: '/cms/'+recentpost.CCTR_path+'/'+recentpost.CCNT_url}"
              >
                <VListItem :class="index? 'mt-2':''">
                  <template #prepend>
                    <VImg
                      :src="portadasUrl+recentpost.CCNT_featured_image"
                      width="100"
                      rounded
                      height="70"
                    />
                  </template>

                  <VListItemTitle>
                    <h6 class="blog-recent-post-title">
                      {{ recentpost.CCNT_title }}
                    </h6>
                  </VListItemTitle>
                  <VListItemSubtitle class="mt-1">
                    <UseTimeAgo 
                      v-slot="{ timeAgo }"
                      :time="recentpost.CCNT_published_at?recentpost.CCNT_published_at.date:recentpost.CCNT_created_at.date"
                      :messages="messages"
                    >
                      {{ timeAgo }}
                    </UseTimeAgo>
                  </VListItemSubtitle>
                </VListItem>
              </NuxtLink>
            </template>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </div>
  <Footer />
</template>

<script setup>
import { useCmsStore } from "@/store/CmsStore"
import { useGeneralStore } from "@/store/GeneralStore"
import { UseTimeAgo } from '@vueuse/components'

definePageMeta({
  layout: 'blank',
  public: true,
})

const route = useRoute()
const slug = ref(route.params?.slug)
const { auth } = storeToRefs(useGeneralStore())
const { post } = storeToRefs(useCmsStore())
const { fetchDataVisit } = useCmsStore()
const { clearBread, addBread } = useGeneralStore()

const messages = ref({
  justNow: useNuxtApp().$i18n.t('just now'),
  past: n => n.match(/\d/) ? useNuxtApp().$i18n.t('ago', [n]) : n,
  future: n => n.match(/\d/) ? useNuxtApp().$i18n.t('in', [n]) : n,
  month: (n, past) => n === 1    ? past
    ? useNuxtApp().$i18n.t('last month')
    : useNuxtApp().$i18n.t('next month')
    : `${n} ${useNuxtApp().$i18n.t(`month${n > 1 ? 's' : ''}`)}`,
  year: (n, past) => n === 1
    ? past
      ? useNuxtApp().$i18n.t('last year')
      : useNuxtApp().$i18n.t('next year')
    : `${n} ${useNuxtApp().$i18n.t(`year${n > 1 ? 's' : ''}`)}`,
  day: (n, past) => n === 1
    ? past
      ? useNuxtApp().$i18n.t('yesterday')
      : useNuxtApp().$i18n.t('tomorrow')
    : `${n} ${useNuxtApp().$i18n.t(`day${n > 1 ? 's' : ''}`)}`,
  week: (n, past) => n === 1
    ? past
      ? useNuxtApp().$i18n.t('last week')
      : useNuxtApp().$i18n.t('next week')
    : `${n} ${useNuxtApp().$i18n.t(`week${n > 1 ? 's' : ''}`)}`,
  hour: n => `${n} ${useNuxtApp().$i18n.t(`hour${n > 1 ? 's' : ''}`)}`,
  minute: n => `${n} ${useNuxtApp().$i18n.t(`minute${n > 1 ? 's' : ''}`)}`,
  second: n => `${n} ${useNuxtApp().$i18n.t(`second${n > 1 ? 's' : ''}`)}`,
})

const loading = ref(false)

const portadasUrl = ref(`${useRuntimeConfig().public.apiURL}/uploads/cms/portadas/`)

const newContent = computed(() =>{
  return post.value.find(p => p.CCNT_url === route.params.slug)
})

const setContent = () => {
  loading.value = true
  fetchDataVisit(route.params.slug).then(response => {
    clearBread()
    addBread({
      order: 1,
      icon: 'tabler-home',
      link: '/noticias',
    })
    
    addBread({
      order: 2,
      label: response.category.CCTR_name,
      link: `/cms/${response.category.CCTR_path}/`,
    })
    addBread({
      order: 3,
      label: response.CCNT_title,
      link: `/cms/${response.category.CCTR_path}/${response.CCNT_url}`,
    })
    loading.value = false
  })
}

watch(
  () => route.params.slug, 
  val => {
    setContent()
  },
)

onBeforeMount(async() =>{
  await setContent()
})
</script>

<style>
.ccntImage {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden
}
.ccntImage img {
    flex-shrink: 0;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}
</style>
